// @noflow
import type {ApiClickedLink} from 'src/types/link-stats';


export const resolveLinkId = ({link, eventId}: ApiClickedLink) =>
  `${eventId}:${link}`;
export const parseLinks = (links: ApiClickedLink[]) =>
  links.map((link) => ({...link, id: resolveLinkId(link)}));
